export const resolveImageSrc = (value) => {
  if (!value) return null
  if (typeof value === 'string' && value.startsWith('data:')) return value
  if (value?.preview && value.preview.startsWith('blob')) return value.preview
  if (value?.preview) return '/' + value.preview
  if (typeof value === 'string' && value.startsWith('gallery')) return '/' + value
  if (value?.path && value?.name) return '/' + value.path + '/' + value.name
  if (Array.isArray(value) && value.length === 0) return null
  return value
}

export const isImageFile = (file) => {
  if (!file) return false
  if (file.type) return file.type.startsWith('image/')
  return /\.(png|jpe?g|gif|webp|svg|bmp|avif)$/i.test(file.name || '')
}
